// Based on http://stackoverflow.com/questions/15900485/correctly-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
var module = angular.module('octopusApp.infrastructure');

module.filter('bytesToSize', function () {
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  return function (input, format) {
    var bytes = parseInt(input, 10);
    if (isNaN(bytes)) {
      return '';
    }
    if (bytes === 0){
      return '0 bytes';
    }
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return +(bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/filters/bytes_to_size.js
// module id = 684
// module chunks = 1